//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MessageWithoutHeader from '@/components/Shared/MessageWithoutHeader.vue'
import ModalAddCollaborator from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/ModalAddCollaborator.vue'
import ModalResendMassive from '@/components/Projects/users/ModalResendMassive.vue'
import { showSuccessNotification } from '@/util/notifications'
import handleErrorMixin from '@/mixins/handleErrorMixin'
import CustomInvitationModal from '../Modals/CustomInvitationModal.vue'
import CollaboratorContainer from './Collaborators/CollaboratorContainer.vue'
import HeaderToolsBar from './Collaborators/HeaderToolsBar.vue'
import MultiselectBar from './Collaborators/MultiselectBar.vue'
import CollaboratorTable from './Collaborators/Table/CollaboratorTable.vue'
import MassiveImportInfoCollaboratorModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/MassiveImportInfoCollaboratorModal.vue'
import MassiveImportCollaboratorModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/MassiveImportCollaboratorModal.vue'
import { INVITATION_TO_PROJECT } from '~/constants/reminder-email-templates'
import ConfirmRegisterMassiveUser from '~/components/Invitation/ConfirmRegisterMassiveUser.vue'
import ROLES from '~/constants/roles'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'
export default {
  components: {
    MessageWithoutHeader,
    CollaboratorContainer,
    HeaderToolsBar,
    MultiselectBar,
    CollaboratorTable,
    ModalAddCollaborator,
    MassiveImportCollaboratorModal,
    MassiveImportInfoCollaboratorModal,
    ModalResendMassive,
    CustomInvitationModal,
    ConfirmRegisterMassiveUser,
  },
  mixins: [handleErrorMixin],
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.projectSupervisors = await this.$repository.user.findSupervisorsByProject(
      {
        project: this.project.id,
      }
    )
    this.getCollaborators()
  },
  data() {
    return {
      search: '',
      selectedRows: [],
      companyEmployees: [],
      collaboratorsWithAssignedSupervisor: [],
      collaboratorsWithProjectRoles: [],
      projectSupervisors: [],

      // Modals
      isShowModalCollaborators: false,
      isShowModalMassiveImportCollaborator: false,
      isShowModalInfoMassiveImportCollaborator: false,
      isShowModalResendMassive: false,
      isShowModalConfirmRegisterMassiveUser: false,
      isShowModalCustomInvitation: false,
      collaboratorsMassiveImportInfo: [],

      emailTemplate: INVITATION_TO_PROJECT,
      roleType: ROLES.EMPLOYEE,
    }
  },
  computed: {
    collaborators() {
      if (!this.search) {
        return this.collaboratorsWithAssignedSupervisor
      }
      return this.collaboratorsWithAssignedSupervisor.filter(
        (supervisorAssignment) => {
          return (
            supervisorAssignment.collaborator.names
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            supervisorAssignment.collaborator.lastnames
              .toLowerCase()
              .includes(this.search.toLowerCase())
          )
        }
      )
    },
    totalCollaboratorsWithoutSupervisor() {
      return this.collaboratorsWithAssignedSupervisor.filter(
        (collaborator) => !collaborator.supervisor
      ).length
    },
  },
  methods: {
    changeChecked(rows) {
      this.selectedRows = rows
    },
    async findEmployeesByCompany(companyId) {
      const companyEmployees = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: companyId,
        }
      )
      return companyEmployees.map((employee) => {
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.project.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          projectRole: projectRole || null,
        }
      })
    },
    async getCollaborators() {
      this.companyEmployees = await this.findEmployeesByCompany(
        this.project.company
      )

      this.collaboratorsWithAssignedSupervisor = await this.$repository.projectRoles.findWithSupervisorAssignmentByProjectId(
        this.project.id
      )

      this.collaboratorsWithProjectRoles = this.collaboratorsWithAssignedSupervisor.map(
        (collaboratorWithSupervisor) => {
          const collaborator = collaboratorWithSupervisor.collaborator
          const projectRole = collaboratorWithSupervisor.collaborator.project_roles?.find(
            (projectRole) =>
              projectRole.project === this.project.id &&
              projectRole.deleted_at === null
          )
          return {
            ...collaborator,
            projectRole: projectRole || null,
          }
        }
      )
    },
    async handleSaveCollaborator() {
      await this.getCollaborators()
      this.isShowModalCollaborators = false
    },
    sendCollaboratorsDetails(collaborators) {
      this.collaboratorsMassiveImportInfo = collaborators
      this.isShowModalMassiveImportCollaborator = false
      this.isShowModalInfoMassiveImportCollaborator = true
    },
    finishMassiveCollaborator() {
      this.isShowModalInfoMassiveImportCollaborator = false
      this.isShowModalCollaborators = false
      this.getCollaborators()
    },
    toggleModalCollaborators() {
      this.isShowModalCollaborators = !this.isShowModalCollaborators
    },
    toggleModalMassiveImportCollaborator() {
      this.isShowModalMassiveImportCollaborator = !this
        .isShowModalMassiveImportCollaborator
    },
    toggleMassiveResend() {
      this.isShowModalResendMassive = !this.isShowModalResendMassive
    },
    toogleModalConfirmRegisterMassiveUser() {
      this.isShowModalConfirmRegisterMassiveUser = !this
        .isShowModalConfirmRegisterMassiveUser
    },
    toggleCustomInvitationModal() {
      this.isShowModalCustomInvitation = !this.isShowModalCustomInvitation
    },
    onEdit(project) {
      this.$emit('edit', project)
      this.isShowModalCustomInvitation = false
    },
    handleConfirmResendMassiveInvitation() {
      this.selectedRows = []
      this.toggleMassiveResend()
      this.toogleModalConfirmRegisterMassiveUser()
    },
    async handleDeleteUser(userId) {
      this.collaboratorsWithAssignedSupervisor = this.collaboratorsWithAssignedSupervisor.filter(
        (collaborator) => collaborator.collaborator.id !== userId
      )
      await this.getCollaborators()
      showSuccessNotification(
        this,
        'El usuario ha sido retirado exitosamente del proyecto.',
        3000
      )
    },
    async handleSelectSupervisor({ supervisorAssignment, rowAssignment }) {
      await this.handleAsiggnSupervisor({
        supervisorId: supervisorAssignment.supervisorId,
        projectId: supervisorAssignment.projectId,
        collaboratorId: supervisorAssignment.collaboratorId,
      })
      await this.getCollaborators()
    },
    async handleAsiggnSupervisor({ supervisorId, projectId, collaboratorId }) {
      try {
        this.$store.commit('loading', true)
        await this.$repository.supervisorAssignments.saveMassiveCollaborators({
          collaboratorsIds: [collaboratorId],
          supervisorId,
          projectId,
          validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
          sendInvitationEmail: true,
        })

        await this.$repository.projectRoles.updateValidationStatus(
          projectId,
          supervisorId,
          true
        )
        showSuccessNotification(this, 'Supervisor asignado correctamente', 3000)
      } catch (error) {
        this.handleError(error, 'Error al asignar el supervisor')
      } finally {
        this.$store.commit('loading', false)
      }
    },
  },
}
